module.exports = __webpack_public_path__ + "static/media/Sensor.9c7f1b13.svg";